import React from "react";
import { Link, useLocation } from "react-router-dom";

const SideMenu = () => {
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="side-menu">
      <div className="menu-items-top">
        <Link to="/" className={`menu-link ${isActive("/") ? "active" : ""}`}>
          <i className="fa-solid fa-house"></i>
          <span>Home</span>
        </Link>

        <Link
          to="/projects"
          className={`menu-link position-relative ${isActive("/projects") ? "active" : ""}`}
        >
          <i className="fa-solid fa-briefcase"></i>
          <span className="notif-badge">46</span>
          <span>Projects</span>
        </Link>

        <Link
          to="/wallet"
          className={`menu-link ${isActive("/wallet") ? "active" : ""}`}
        >
          <i className="fa-solid fa-wallet"></i>
          <span>Wallet</span>
        </Link>

        <Link
          to="/refer"
          className={`menu-link ${isActive("/refer") ? "active" : ""}`}
        >
          <i className="fa-solid fa-user-group"></i>
          <span>Refer a Friend</span>
        </Link>
      </div>

      <div className="menu-items-bottom mt-auto">
        <hr className="menu-divider" />

        <Link
  to="/profile"
  className={`menu-link mx-auto ${
    ["/profile", "/measurement", "/notification", "/team", "/support-ticket"].includes(location.pathname) ? "active" : ""
  }`}
>
  <i className="fa-solid fa-gear"></i>
  <span>Setting</span>
</Link>

        <Link
          to="/usage"
          className={`menu-link mx-auto ${isActive("/usage") ? "active" : ""}`}
        >
          <i className="fa-solid fa-chart-pie"></i>
          <span>Usage Summary</span>
        </Link>

        <Link
          to="/help"
          className={`menu-link mx-auto ${isActive("/help") ? "active" : ""}`}
        >
          <i className="fa-solid fa-circle-question"></i>
          <span>Help & Support</span>
        </Link>

        <div className="sidebar-footer">
          {/* <div>© 2023</div> */}
          <div>© 2023 Measro.com</div>
        </div>
      </div>
    </nav>
  );
};

export default SideMenu;
